// extracted by mini-css-extract-plugin
module.exports = {"relatedContent":"relatedContent_relatedContent__ntUDa","heading":"relatedContent_heading__FvZdT","contentWrapper":"relatedContent_contentWrapper__dcblW"};